import { useQuery } from '@hooks/useQuery';
import { useEffect } from 'react';
import dayjs from 'dayjs';

/** Take Query strings, create a state cookie */
export const LandingEffects = () => {
  /** Effect hook that pushes Query params to local storage as state.
   *  Expire after 5 minutes.
   */
  const queryStrings = useQuery();

  /**
   * Cases: Have Query strings
   *   Have Persisted Keys
   *
   */
  useEffect(() => {

    try {
      const persisted = localStorage.getItem('MO_TICKETS');
      /** Bounce if no query strings */
      if(!queryStrings.get('serialNum') && persisted) return;

      /** Set an expiration time */
      const toBePersisted = {
        expires: dayjs().add(5, 'minutes')
      } as Record<string, any>;


      /** Guard Clause - RM if expired */
      if(JSON.parse(persisted!) && dayjs().isAfter(JSON.parse(persisted!).expires)){
        localStorage.removeItem('MO_TICKETS');
        return;
      }

      /** If they have query strings, record them */
      for (const [k, v] of queryStrings.entries()){
        toBePersisted[k] ??= v;
      }

      localStorage.setItem('MO_TICKETS', JSON.stringify(toBePersisted));
  } catch (e) {
    localStorage.removeItem('MO_TICKETS');
  }

  }, [queryStrings]);

  return (<></>);
};